// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingRotate {
    constructor({ state, elements }) {
      if (
        !state ||
        !elements?.object ||
        !elements?.rotateHandle
      ) {
        throw new Error(
          "[EspacioLaserV2] Rotate requiere state, object y rotateHandle."
        );
      }

      this.state = state;
      this.object = elements.object;

      this.content =
        elements.content ||
        elements.previewText;

      this.handle = elements.rotateHandle;

      this.abortController =
        new AbortController();

      this.rotating = false;

      this.centerX = 0;
      this.centerY = 0;

      this.startPointerAngle = 0;
      this.startRotation = 0;

      this.bindEvents();
    }

    bindEvents() {
      const { signal } =
        this.abortController;

      this.handle.addEventListener(
        "pointerdown",
        (event) => this.start(event),
        { signal }
      );

      window.addEventListener(
        "pointermove",
        (event) => this.move(event),
        { signal }
      );

      window.addEventListener(
        "pointerup",
        (event) => this.end(event),
        { signal }
      );

      window.addEventListener(
        "pointercancel",
        (event) => this.end(event),
        { signal }
      );
    }

    start(event) {
      event.preventDefault();
      event.stopPropagation();

      /*
       * Calculamos el centro una sola vez
       * al comenzar la rotación.
       *
       * No debe recalcularse durante el giro,
       * porque el bounding box cambia al rotar.
       */
      const center = this.getCenter();

      this.centerX = center.x;
      this.centerY = center.y;

      this.startPointerAngle =
        this.getAngle(
          this.centerX,
          this.centerY,
          event.clientX,
          event.clientY
        );

      this.startRotation =
        Number(
          this.state.transform.rotation
        ) || 0;

      this.rotating = true;

      this.state.setUI(
        "rotating",
        true
      );

      this.state.setUI(
        "selected",
        true
      );

      this.handle.setPointerCapture?.(
        event.pointerId
      );
    }

    move(event) {
      if (!this.rotating) return;

      event.preventDefault();
      event.stopPropagation();

      const currentPointerAngle =
        this.getAngle(
          this.centerX,
          this.centerY,
          event.clientX,
          event.clientY
        );

      let difference =
        currentPointerAngle -
        this.startPointerAngle;

      /*
       * Evita saltos cuando el ángulo
       * atraviesa la frontera entre
       * 180° y -180°.
       */
      if (difference > 180) {
        difference -= 360;
      }

      if (difference < -180) {
        difference += 360;
      }

      this.state.setRotation(
        this.startRotation + difference
      );
    }

    end(event) {
      if (!this.rotating) return;

      this.rotating = false;

      this.state.setUI(
        "rotating",
        false
      );

      if (
        event?.pointerId !== undefined &&
        this.handle.hasPointerCapture?.(
          event.pointerId
        )
      ) {
        this.handle.releasePointerCapture(
          event.pointerId
        );
      }
    }

    getCenter() {
  const rect =
    this.object.getBoundingClientRect();

  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
  };
}

    getAngle(
      centerX,
      centerY,
      pointerX,
      pointerY
    ) {
      return (
        Math.atan2(
          pointerY - centerY,
          pointerX - centerX
        ) *
        (180 / Math.PI)
      );
    }

    destroy() {
      this.abortController.abort();
    }
  }

  EL.EngravingRotate =
    EngravingRotate;
})();